"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_1 = __importStar(require("react"));
const react_native_paper_1 = require("react-native-paper");
const eventConstants_1 = require("../../../constants/eventConstants");
const styles_1 = __importDefault(require("../../../styles/styles"));
const icon_1 = __importDefault(require("../../icon/icon"));
const pressable_1 = __importDefault(require("../../pressable/pressable"));
const CommunicationBoxDropdown = ({ voipCallProviders, action, }) => {
    const [visible, setVisible] = react_1.useState(false);
    const toggleMenu = () => setVisible(!visible);
    const menuItemHandler = (provider) => {
        action(provider);
        toggleMenu();
    };
    const anchor = (react_1.default.createElement(pressable_1.default, { style: [styles_1.default.marginFive], onPress: toggleMenu, eventName: eventConstants_1.MENU_DROPDOWN },
        react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faEllipsisV, size: 25 })));
    return (react_1.default.createElement(react_native_paper_1.Menu, { visible: visible, onDismiss: toggleMenu, anchor: anchor, contentStyle: styles_1.default.whiteBackground }, voipCallProviders.map((el) => (react_1.default.createElement(react_native_paper_1.Menu.Item, { titleStyle: styles_1.default.textColorBlack, key: el.display_value, onPress: () => menuItemHandler(el.backend_value), title: el.display_value })))));
};
exports.default = CommunicationBoxDropdown;
